import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { SurveyTemplateTypes } from 'types/survey_template.types';

export interface CreateSurveyTemplateResult {
  createSurveyTemplate: {
    surveyTemplate: {
      id: string;
    };
  };
}

export interface CreateSurveyTemplateVariables {
  title: string;
  description: string;
  type: SurveyTemplateTypes;
}

export const CREATE_SURVEY_TEMPLATE = gql`
  mutation CreateSurveyTemplate($title: String!, $description: String!, $type: String!) {
    createSurveyTemplate(input: { title: $title, description: $description, type: $type }) {
      surveyTemplate {
        id
      }
    }
  }
`;

export const createSurveyTemplate = async (
  variables: CreateSurveyTemplateVariables
): Promise<CreateSurveyTemplateResult> => {
  return gqlClient.request(CREATE_SURVEY_TEMPLATE, variables);
};
